import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/course',
    name: 'course',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/CourseView.vue')
  },
  {
    path: '/personal-center',
    name: 'personalCenter',
    component:()=>import('../views/PersonalCenterView.vue')
  },
  {
    path: '/course-more/:id/:coursetypename',
    name: 'courseMore',
    component: () => import('../views/CourseMoreView.vue')
  },
  {
    path: '/course/information/:courseId',
    name: 'information',
    component: () => import('../views/CourseInfomation.vue')
  },
  {
    path: '/course/video/:courseId',
    name: 'video',
    meta: { layout: 'none' },
    component: () => import('../views/CourseVideoView.vue')
  },
  {
    path: '/usercenter',
    name: 'usercenter',
    component: () => import('../views/user/UserCenterView.vue')
  },

  {
    path: '/admin-home',
    name: 'adminHome',
    component: () => import('../views/admin/AdminHomView.vue'),
    children: [
      {
        path: '/adminhome/usermanagement',
        component:()=>import("@/views/admin/UserManageView.vue"),
      },
    //   {
    //     path: '/adminhome/newsmanagement',
    //     component:()=>import("@/views/admin/NewsEditorView.vue"),
    //   },
      {
        path: "/adminhome/milestone",
        component: ()=>import("@/views/admin/WebsiteMilestone.vue")
      },
    //   {
    //     path: "/adminhome/createcourse",
    //     component:()=>import('@/views/admin/CreateCourse.vue')
    //   },
    //   {
    //     path: "/adminhome/addteacher",
    //     component:()=>import('@/views/admin/CreateTeacherView.vue')
    //   },
    //   {
    //     path: '/adminhome/updateCourse',
    //     component: () => import('@/views/admin/UpdateCourseView.vue'),
    //   },
    //   {
    //     path: '/adminhome/CourseOfProcess/:userid',
    //     name: 'CourseOfProcess',
    //     component:()=>import('@/views/admin/StudentProcessOfCouresView.vue')
    //   },
    //   {
    //     path: '/adminhome/CourseOfProcess/:userid/:courseid',
    //     name: 'CourseOfProcessDetail',
    //     component:()=>import('@/views/admin/UserCourseDetailView.vue')
    //   },
    ],
  },

  { path: '/testhome', name: 'TestHome', component: ()=>import('@/views/assessment/TestHome.vue')},
  { path: '/test/:id', name: 'TestDetail', component: () => import("@/views/assessment/TestDetail.vue"), props: true },
   { path: '/teststart/:id', name: 'TestStart', component: ()=>import("@/views/assessment/TestStart.vue"), props: true },
  { path: '/result/:id', name: 'TestResult', component: ()=>import("@/views/assessment/TestResult.vue"), props: true }
 


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
